import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import { createSocket } from '../utils/websocket'
import axios from 'axios'
import API from '../api'

const routes = [
	{
		alias: '/',
		path: '/',
		name: 'home', // 首页
		// meta: { keepAlive: true },
		component: () => import('@/views/home/home'),
		children: [
			{
				path: '/patientDetail',
				name: 'patientDetail', // 首页
				component: () => import('@/views/patientDetail/patientDetail'),
			},
			{
				path: '/consultation',
				name: 'consultation', // 问诊
				component: () => import('@/views/consultation/consultation'),
			},
			{
				path: '/videoPage',
				name: 'videoPage', // 问诊
				// meta: { keepAlive: true },
				component: () => import('@/views/videoPage/videoPage'),
			},
			{
				path: '/waiting',
				name: 'waiting', // 问诊
				// meta: { keepAlive: true },
				component: () => import('@/views/waiting/waiting'),
			},
			{
				path: '/specialistWait/waiting',
				name: 'sw',
				component: () => import(/*  webpackChunkName:"spWaiting" */ '@/views/specialistWait/index'),
			},
			{
				path: '/trtcCalling',
				name: 'trtcCalling', // 问诊
				// meta: { keepAlive: true },
				component: () => import('@/views/trtcCallingPage/trtcCalling'),
			},
			{
				path: '/pre/inquiry',
				name: 'preInquiry',
				component: () => import(/*  webpackChunkName:"preinquiry" */ '@/views/preInquiry/index'),
			},
			{
				path: '/test',
				name: 'test',
				component: () => import(/*  webpackChunkName:"test" */ '@/views/test'),
			},
			{
				path: '/calling',
				name: 'calling',
				component: () => import(/*  webpackChunkName:"calling" */ '@/views/video/calling'),
			},
			{
				path: '/video/page',
				name: 'videoPage',
				component: () => import(/*  webpackChunkName:"videoPage" */ '@/views/video/index'),
			},

			{
				path: '/rpViewer',
				name: 'rpViewer',
				component: () => import(/*  webpackChunkName:"rpViewer" */ '@/views/rpViewer'),
			},
			{
				path: '/autoVideo',
				name: 'autoVideo',
				component: () => import(/*  webpackChunkName:"rpViewer" */ '@/views/autoVideo'),
			},
		],
	},
]

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (from.meta.keepAlive) {
				const selector = document.getElementById('scrollbar') || {}
				from.meta.savedPosition = selector.scrollTop || 0
			}
			return { x: 0, y: to.meta.savedPosition || 0 }
		}
	},
})

let time = null

router.beforeEach(async (to, from, next) => {
	let name = to.name
	let nameStr = ''
	try {
		let patientId = store.state.user.orderDetail.orderPatientID || store.state.user.userInfo.orderPatientID
		let token = store.state.user.userInfo.token
		if (name === 'home') {
			nameStr = '首页'
		} else if (patientId && token) {
			createSocket(process.env.VUE_APP_WEBSOCKET_URL, patientId, token)
		}
		clearInterval(time)
		time = setInterval(() => {
			if (store.state.user.userInfo.keyID && nameStr) {
				axios.post(API.TMC_POST_PATIENT_TRACE_HEART, {
					patientID: store.state.user.userInfo.keyID,
					path: to.path,
					channelCode: 'tmch5',
					channelName: 'h5',
					pathName: nameStr
				})
			}
		}, 2000)
	} catch (error) {
		console.error(error)
	}
	next()
})

export default router
